import {
  mdiCalendarClock,
  mdiCalendarMultiselectOutline,
  mdiCash100,
  mdiFileDocumentEditOutline,
  mdiFinance,
  mdiImageMultiple,
  mdiMonitorDashboard,
  mdiPackageVariantClosed,
  mdiPhoneClock,
  mdiViewDashboardEditOutline,
  mdiWashingMachine,
  mdiCog,
  mdiBellOutline,
} from '@mdi/js'

export const routes = [
  {
    label: 'Dashboard',
    icon: mdiViewDashboardEditOutline,
    key: 'dashboard',
    childrens: [
      {
        route: '/dashboard-financial',
        title: 'Financeiro',
        role: ['read-dashboard-financeiro'],
      },
      {
        route: '/lead',
        title: 'Leads',
        role: ['read-dashboard-leads'],
      },
      {
        route: '/',
        title: 'Itens',
        role: ['read-dashboard-itens'],
      },
    ],
  },
  {
    label: 'Atendimentos',
    icon: mdiPhoneClock,
    key: 'atendimentos',
    route: '/attendance',
    role: ['read-atendimentos'],
    childrens: [],
  },
  {
    label: 'Fotos dos Itens',
    icon: mdiImageMultiple,
    key: 'fotos-tapete',
    route: '/service-item-history',
    role: ['read-fotos-tapete'],
    childrens: [],
  },
  {
    label: 'Calendário',
    icon: mdiCalendarMultiselectOutline,
    key: 'calendario',
    route: '/calendar',
    role: ['read-calendario'],
    childrens: [],
  },
  {
    label: 'Cadastros',
    icon: mdiFileDocumentEditOutline,
    key: 'cadastros',
    childrens: [
      {
        route: '/knowWay',
        title: 'Como Conheceu',
        role: ['read-como-conheceu', 'create-como-conheceu'],
      },
      {
        route: '/users',
        title: 'Usuários',
        role: ['read-usuarios', 'create-usuarios'],
      },
      {
        route: '/clients',
        title: 'Clientes',
        role: ['read-clientes', 'create-clientes'],
      },
      {
        route: '/laundry-clients',
        title: 'Cliente Lavanderias',
        role: ['read-laundry-client', 'create-laundry-client'],
      },
      {
        route: '/client-plan',
        title: 'Planos de Clientes',
        role: ['client-plan-list'],
      },
      {
        route: '/service-category',
        title: 'Categorias de serviço',
        role: ['read-categorias-servico', 'create-categorias-servico'],
      },
      {
        route: '/service-type',
        title: 'Tipos de serviço',
        role: ['read-tipos-servico', 'create-tipos-servico'],
      },
      {
        route: '/payment-method',
        title: 'Formas de pagamento',
        role: ['read-formas-pagamento', 'create-formas-pagamento'],
      },
    ],
  },
  {
    label: 'Estoque',
    icon: mdiPackageVariantClosed,
    key: 'estoque',
    route: '/stock',
    role: ['read-estoque'],
    childrens: [],
  },
  {
    label: 'Relatórios',
    icon: mdiCalendarClock,
    key: 'relatorios',
    childrens: [
      {
        route: '/relatory-birth',
        title: 'Aniversariantes',
        role: ['read-relatorios-aniversariantes'],
      },
      {
        route: '/relatory-catalogacao',
        title: 'Catalogação',
        role: ['read-relatorios-catalogacao'],
      },
      {
        route: '/relatory-clients',
        title: 'Clientes',
        role: ['read-relatorios-clientes'],
      },
      // {
      //   route: '/relatory-prospects',
      //   title: 'Prospects',
      //   role: ['read-relatorios-prospects'],
      // },
      {
        route: '/relatory-services',
        title: 'Atendimentos',
        role: ['read-relatorios-atendimentos'],
      },
      {
        route: '/relatory-schedules',
        title: 'Agendamento',
        role: ['read-relatorios-agendamento'],
      },
      {
        route: '/relatory-stock',
        title: 'Estoque',
        role: ['read-relatorios-estoque'],
      },
      {
        route: '/relatory-commission',
        title: 'Comissão',
        role: ['read-relatorios-comissao'],
      },
      {
        route: '/relatory-service-category',
        title: 'Categoria de Serviços',
        role: ['read-relatorios-categoria-servicos'],
      },
      {
        route: '/relatory-team-produtivity',
        title: 'Produção Equipe',
        role: ['read-relatorios-producao-equipe'],
      },
      {
        route: '/relatory-technical-absences',
        title: 'Ausência de Técnicos',
        role: ['read-relatorios-ausencia-tecnicos'],
      },
      {
        route: '/laundry-client-billings',
        title: 'Faturas',
        role: ['laundry-client-billing-list'],
      },
    ],
  },
  {
    label: 'Financeiro',
    icon: mdiFinance,
    key: 'modulo-financeiro',
    childrens: [
      {
        route: '/supplier',
        title: 'Contatos Financeiros',
        role: ['read-contatos-financeiros', 'create-contatos-financeiros'],
      },
      {
        route: '/billing-type',
        title: 'Centro de custo',
        role: ['read-centro-custo', 'create-centro-custo'],
      },
      {
        route: '/billing',
        title: 'Lançamento de contas',
        role: ['read-lancamento-contas', 'create-lancamento-contas'],
      },
      {
        route: '/dre',
        title: 'DRE',
        role: ['read-dre', 'create-dre'],
      },
      {
        route: '/bank',
        title: 'Bancos',
        role: ['read-bancos', 'create-bancos'],
      },
    ],
  },
  {
    label: 'CRM',
    icon: mdiMonitorDashboard,
    key: 'modulo-crm',
    childrens: [
      {
        route: '/crm/panel',
        title: 'Painel CRM',
        role: ['read-painel-crm', 'create-painel-crm'],
      },
      {
        route: '/crm/triggers',
        title: 'Gatilhos',
        role: ['read-gatilhos', 'create-gatilhos'],
      },
      {
        route: '/crm/reports/leads',
        title: 'Relatório de Leads',
        role: ['read-relatorio-leads', 'create-relatorio-leads'],
      },
      {
        route: '/crm/reports/gerency',
        title: 'Relatório Gerencial',
        role: ['read-relatorio-gerencial', 'create-relatorio-gerencial'],
      },
    ],
  },
  {
    label: 'Módulo Parceiros',
    icon: mdiWashingMachine,
    key: 'modulo-parceiros',
    childrens: [
      {
        route: '/partners-module/partners',
        title: 'Parceiros',
        role: ['read-modulo-parceiros', 'create-modulo-parceiros'],
      },
      {
        route: '/partners-module/oss',
        title: 'OSs',
        role: [
          'read-modulo-parceiros-oss',
          'create-modulo-parceiros-oss',
          'update-modulo-parceiros-oss',
        ],
      },
      {
        route: '/partners-module/appointments',
        title: 'Agendamentos',
        role: [
          'read-modulo-parceiros-agendamentos',
          'create-modulo-parceiros-agendamentos',
        ],
      },
      {
        route: '/partners-module/items-report',
        title: 'Relátorio de Itens',
        role: ['read-modulo-parceiros-relatorio-itens'],
      },
      {
        route: '/partners-module/dashboard',
        title: 'Dashboard',
        role: ['read-modulo-parceiros-dashboard'],
      },
    ],
  },
  {
    label: 'Cashback',
    icon: mdiCash100,
    key: 'modulo-cashback',
    childrens: [
      {
        route: '/cashback-module/conversion',
        title: 'Cadastro de Conversão',
        role: ['read-cashback-conversao', 'create-cashback-conversao'],
      },
      {
        route: '/cashback-module/extract',
        title: 'Extrato',
        role: ['read-cashback-extrato', 'create-cashback-extrato'],
      },
      {
        route: '/cashback-module/point-value',
        title: 'Valor do Ponto',
        role: ['read-cashback-valor-ponto', 'create-cashback-valor-ponto'],
      },
    ],
  },
  {
    label: 'Alertas',
    icon: mdiBellOutline,
    key: 'alertas',
    route: '/alerts',
    rolesAllowed: ['administrador'],
    childrens: [],
  },
  {
    label: 'Configurações',
    icon: mdiCog,
    key: 'configuracoes',
    route: '/settings',
    role: ['read-configuracoes'],
    childrens: [],
  },
]

// Exports individuais para manter compatibilidade
export const dashboard = routes.find(r => r.key === 'dashboard').childrens
export const registrations = routes.find(r => r.key === 'cadastros').childrens
export const reports = routes.find(r => r.key === 'relatorios').childrens
export const financial = routes.find(
  r => r.key === 'modulo-financeiro'
).childrens
export const crm = routes.find(r => r.key === 'modulo-crm').childrens
export const partners = routes.find(r => r.key === 'modulo-parceiros').childrens
export const cashback = routes.find(r => r.key === 'modulo-cashback').childrens
